import { render, staticRenderFns } from "./CustomFieldTable.vue?vue&type=template&id=a2a026b8"
import script from "./CustomFieldTable.vue?vue&type=script&lang=js"
export * from "./CustomFieldTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports